import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { DialogContext } from '../../context/DialogContext';
import { UserContext } from '../../context/UserContext';
import { TestingHqContext } from '../../context/TestingHqContext';
import { TestingContext } from '../../context/TestingContext';

import List from '../../components/list/List';
import ImageView from '../image_view';
import TestingPlaceJoin from './join';
import TestingPlaceDetail from './detail';
import EditableText from '../../components/EditableText';
import { get_testing_place_list, get_testing_type, get_testing_list, upsert_testing_place, upsert_place } from '../../utils/restapi';
import { TESTING_PLACE_ISUSE } from '../../constants/testing_place';
import './list.css';

const TestingPlaceList = () => {
  const { user } = useContext(UserContext);
  const { testingHqs } = useContext(TestingHqContext);
  const { testingObj, setTestingObj } = useContext(TestingContext);

  const { openDialog, closeDialog } = useContext(DialogContext);
  const listRef = useRef(null);
  const navigate = useNavigate();

  // 시험유형 관련 상태만 유지
  const [testingTypes, setTestingTypes] = useState([]);
  const [testings, setTestings] = useState([]);


  // List에서 사용할 데이터 가져오기 함수
  const handleGetData = async (params) => {
    const requestParams = {
      type: parseInt(testingObj?.type || 0),
      testing_id: parseInt(testingObj?.testing_id || 0),
      gcode: testingHqs.map(hq => hq.code).join(','),
      ...params
    };

    console.log("handleGetData requestParams:", requestParams);
    return await get_testing_place_list(requestParams);
  };

  // 자세히 보기 다이얼로그 열기
  const handleDetailClick = (item) => {
    const customStyles = {
      overlay: { backgroundColor: 'rgba(0, 0, 0, 0.5)' },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };
    openDialog(
      <TestingPlaceDetail item={item} onClose={closeDialog} />,
      customStyles
    );
  };

  // 약도 이미지 다이얼로그 열기
  const handleMapClick = (item) => {
    const mapUrl = `https://www.klata.or.kr${item.map.url}`;
    const title = `${item.name} 약도`;

    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };

    openDialog(
      <ImageView 
        title={title}
        url={mapUrl}
        onClose={closeDialog}
      />, 
      customStyles
    );
  };

  // 정보수정 다이얼로그 열기
  const handleJoinClick = () => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };

    const handleClose = () => {
      closeDialog();
      // 다이얼로그 닫힌 후 목록 새로고침
      // handleGetList(); // 이 줄을 제거하고 아래로 교체
      if (listRef.current) {
        listRef.current.refresh();
      }
    };

    openDialog(
      <TestingPlaceJoin
        title={`${testings.find(t => t.testing_id === parseInt(testingObj.testing_id))?.title || ''} 고사장 등록`}
        testingPlaceObj={null}
        onClose={handleClose}
      />, 
      customStyles
    );
  };

  // 정보수정 다이얼로그 열기
  const handleEditClick = (item) => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };

    const handleClose = () => {
      closeDialog();
      // 다이얼로그 닫힌 후 목록 새로고침
      // handleGetList(); // 이 줄을 제거하고 아래로 교체
      if (listRef.current) {
        listRef.current.refresh();
      }
    };

    openDialog(
      <TestingPlaceJoin
        title={`${item.testingObj.title} ${item.name} 정보수정`}
        testingPlaceObj={item}
        onClose={handleClose}
      />, 
      customStyles
    );
  };

  // 삭제 기능
  const handleDeleteClick = async (item) => {
    if (window.confirm(`이번 회차에 ${item.name} 고사장을 정말 삭제하시겠습니까?`)) {
      const json = {
        testing_place_id: item.testing_place_id,
        isUse: 9
      };

      try {
        await upsert_testing_place(json);
        alert(`${item.name} 고사장이 삭제 요청되었습니다.`);
        // 목록 새로고침
        if (listRef.current) {
          listRef.current.refresh();
        }
      } catch (error) {
        console.error("Error deleting testing place:", error);
        alert(`${item.name} 고사장이 삭제 요청에 실패하였습니다.`);
        return;
      }
    }
  };

  // 시험유형 데이터 가져오기
  const getTestingTypes = async () => {
    console.log('getTestingTypes called');
    try {
      const response = await get_testing_type();
      console.log("getTestingTypes:", response);
      setTestingTypes(response); // API 응답 구조에 따라 조정
    } catch (error) {
      console.error("Error fetching types:", error);
    }
  };

  // 시험에 대한 데이터 가져오기
  const getTestings = async (type) => {
    if (!type) {
      setTestings([]);
      return;
    }
    try {
      const response = await get_testing_list({ type, page:1, rowsPerPage:1000, sort:'a_testing_id', desc:'desc' });
      // 실제 응답 구조 확인
      console.log("getTestings response:", response);
      setTestings(response.lists); // 응답 구조에 따라 조정
    } catch (error) {
      setTestings([]);
    }
  };

  // 시험유형 선택 핸들러
  const handleTestingTypeChange = (e) => {
    if (listRef.current) {
      listRef.current.resetItems();
    }

    console.log('handleTestingTypeChange called');
    const selectedValue = e.target.value;
    setTestingObj({ ...testingObj, type: selectedValue });
    console.log("selectedTestingType:", selectedValue);

    // 선택된 시험유형에 따라 시험 목록과 고사장 목록 다시 불러오기
    if (selectedValue) {
      getTestings(selectedValue);
    } else {
      setTestings([]); // 빈 값 선택시 시험 목록 초기화
    }
  };

  // 시험 선택 핸들러 수정
  const handleTestingIdChange = (e) => {
    if (listRef.current) {
      listRef.current.resetItems();
    }

    console.log('handleTestingIdChange called');
    const selectedValue = e.target.value;
    const selectedTesting = testings.find(obj => obj.testing_id === parseInt(selectedValue));
    setTestingObj(selectedTesting || null);
    
    // 선택된 시험에 따라 고사장 목록 다시 불러오기
    if (selectedValue) {
      listRef.current.refresh();
    }
  };

  // 고사실 수 변경
  const handleRoomsChanged = (item, rooms) => {
    console.log('[handleRoomsChanged] item : ', item);
    
    const json = {
      ...item,
      rooms
    }

    console.log('[handleRoomsChanged] json : ', json);

    upsert_testing_place(json)
      .then(response => {
        console.log("upsert_testing_place response:", response);
        // handleItemChanged(item, 'rooms', rooms); // 주석 처리
        // List 컴포넌트 새로고침
        if (listRef.current) {
          listRef.current.refresh();
        }
      })
      .catch(error => {
        console.error("Error updating testing place:", error);
        alert(`고사실수 업데이트 실패: ${error.message}`);
      });
  }

  // 최대 접수 가능 인원 변경
  const handleMaxCountChanged = (item, maxCount) => {
    console.log('[handleMaxCountChanged] item : ', item);

    const json = {
      ...item,
      maxCount
    }

    console.log('[handleMaxCountChanged] json : ', json);

    upsert_testing_place(json)
      .then(response => {
        console.log("upsert_testing_place response:", response);
        // handleItemChanged(item, 'maxCount', maxCount); // 주석 처리
        // List 컴포넌트 새로고침
        if (listRef.current) {
          listRef.current.refresh();
        }
      })
      .catch(error => {
        console.error("Error updating testing place:", error);
        alert(`최대 접수 가능 인원 업데이트 실패: ${error.message}`);
      });
  };

  // 주소(지번) 변경
  const handleAddressMainChanged = (item, addressMain) => {
    console.log('[handleAddressMainChanged] item : ', item);

    const json = {
      ...item,
      addressMain
    }

    console.log('[handleAddressMainChanged] json : ', json);

    upsert_place(json)
      .then(response => {
        console.log("upsert_place response:", response);
        // handleItemChanged(item, 'addressMain', addressMain); // 주석 처리
        // List 컴포넌트 새로고침
        if (listRef.current) {
          listRef.current.refresh();
        }
      })
      .catch(error => {
        console.error("Error updating place:", error);
        alert(`주소 업데이트 실패: ${error.message}`);
      });
  };

  // 주소(지번) 변경
  const handleAddressDetailChanged = (item, addressDetail) => {
    console.log('[handleAddressDetailChanged] item : ', item);

    const json = {
      ...item,
      addressDetail
    }

    console.log('[handleAddressDetailChanged] json : ', json);

    upsert_testing_place(json)
      .then(response => {
        console.log("upsert_testing_place response:", response);
        // handleItemChanged(item, 'addressDetail', addressDetail); // 주석 처리
        // List 컴포넌트 새로고침
        if (listRef.current) {
          listRef.current.refresh();
        }
      })
      .catch(error => {
        console.error("Error updating testing place:", error);
        alert(`주소 업데이트 실패: ${error.message}`);
      });
  };

  // 전화번호 변경
  const handlePhoneChanged = (item, phone) => {
    console.log('[handlePhoneChanged] item : ', item);

    const json = {
      ...item,
      phone
    }

    console.log('[handlePhoneChanged] json : ', json);

    upsert_testing_place(json)
      .then(response => {
        console.log("upsert_testing_place response:", response);
        // handleItemChanged(item, 'phone', phone); // 주석 처리
        // List 컴포넌트 새로고침
        if (listRef.current) {
          listRef.current.refresh();
        }
      })
      .catch(error => {
        console.error("Error updating testing place:", error);
        alert(`전화번호 업데이트 실패: ${error.message}`);
      });
  };

  // headers에 renderCell 함수를 포함시킴
  const headers = [
    { 
      name: 'NO.', 
      value: 'a_testing_place_id',
      renderCell: (item) => item.testing_place_id
    },
    { 
      name: '고사장명', 
      value: 'a_name',
      renderCell: (item) => item.name
    },
    { 
      name: '고사실수', 
      value: 'a_rooms',
      renderCell: (item) => (
        <EditableText 
          type="number" 
          name="rooms" 
          value={item.rooms} 
          onChange={(newValue) => handleRoomsChanged(item, newValue)} 
        />
      )
    },
    { 
      name: '가용인원', 
      value: 'a_maxCount',
      renderCell: (item) => (
        <EditableText 
          type="number" 
          name="maxCount" 
          value={item.maxCount} 
          onChange={(newValue) => handleMaxCountChanged(item, newValue)} 
        />
      )
    },
    { 
      name: '주소', 
      value: 'b_addressMain',
      renderCell: (item) => (
        <>
          <EditableText 
            type="text" 
            name="addressMain" 
            value={item.placeObj.addressMain} 
            onChange={(newValue) => handleAddressMainChanged(item, newValue)} 
          />
          <EditableText 
            type="text" 
            name="addressDetail" 
            value={item.placeObj.addressDetail} 
            onChange={(newValue) => handleAddressDetailChanged(item, newValue)} 
          />
        </>
      )
    },
    { 
      name: '전화번호', 
      value: 'a_phone',
      renderCell: (item) => (
        <EditableText 
          type="text" 
          name="phone" 
          value={item.placeObj.phone} 
          onChange={(newValue) => handlePhoneChanged(item, newValue)} 
        />
      )
    },
    { 
      name: '약도', 
      value: '',
      renderCell: (item) => item.map ? (
        <button 
          onClick={() => handleMapClick(item)}
          style={{ 
            background: 'none', 
            border: 'none', 
            color: '#007bff', 
            textDecoration: 'underline', 
            cursor: 'pointer' 
          }}
        >
          약도
        </button>
      ) : ''
    },
    { 
      name: '주차', 
      value: 'a_parking',
      renderCell: (item) => item.parking_info
    },
    {
      name: '상태',
      value: 'a_isUse',
      renderCell: (item) => TESTING_PLACE_ISUSE.name[item.isUse] || '-'
    },
    {
      name: '상세',
      value: '',
      renderCell: (item) => (
        <button onClick={() => handleDetailClick(item)}>자세히 보기</button>
      )
    },
  ];

  // buttons 정의 - listRef에서 선택된 항목 가져오기
  const buttons = [
    {
      text: '등록',
      onClick: () => navigate('/testing_place/joins'),
    },
  ];

  // 시험유형 변경 시 listRef 새로고침
  useEffect(() => {
    if (testingObj && testingObj.testing_id) {
      handleGetData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.testing_id]);

  // 컴포넌트가 처음 마운트될 때 시험유형 로드
  useEffect(() => {
    getTestingTypes();
    getTestings();
  }, []);

  useEffect(() => {
    if (testingObj?.type) {
      getTestings(testingObj.type);
    } else {
      setTestings([]);
    }

    listRef.current?.resetItems();
  }, [testingObj?.type]);

  useEffect(() => {
    if (testingObj && testingObj.testing_id) {
      handleGetData();
    } else {
      listRef.current?.resetItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.testing_id]);

  // 행 클릭 이벤트 (옵션)
  const handleRowClick = (item) => {
    console.log('Row clicked:', item);
    // 필요시 행 클릭 시 동작 정의
  };

  return (
    <div id="testing_place_list">
      <div className="head">
        <h1>회차별 고사장 목록</h1>
      </div>
      <div className="body">
        <div className="top">
          <ul className="form">
            <li>
              <label>구분</label>
              <span>
                <select value={testingObj?.type || ''} onChange={handleTestingTypeChange}>
                  <option value="">▒ 선택 ▒</option>
                  {testingTypes.map((obj, index) => (
                    <option key={index} value={obj.code}>
                      {obj.nickname || obj.name}
                    </option>
                  ))}
                </select>
              </span>
            </li>
            <li>
              <label>시험</label>
              <span>
                <select value={testingObj?.testing_id || ''} onChange={handleTestingIdChange}>
                  <option value="">▒ 선택 ▒</option>
                  {testings.map((obj, index) => (
                    <option key={index} value={obj.testing_id}>
                      {obj.title}
                    </option>
                  ))}
                </select>
              </span>
            </li>
          </ul>
        </div>
        <div className="middle">
          <List
            ref={listRef}
            headers={headers}
            buttons={buttons}
            onGetData={handleGetData}
            onRowClick={handleRowClick}
            className="testing_place_table"
            initialSort="a_testing_place_id"
            initialDesc="desc"
            initialRowsPerPage={20}
          />
        </div>
        <div className="bottom">
        </div>
      </div>
    </div>
  );
};

export default TestingPlaceList;
